import { Select2OptionData } from "ng-select2";

export const JOB_POSITION: Array<Select2OptionData> =
    [
        { id: '236', text: 'Abogado/a' },
        { id: '237', text: 'Administrador/a' },
        { id: '183', text: 'Ajedrez (ACLE / Taller)' },
        { id: '4', text: 'Asesor/a Educativo/a' },
        { id: '175', text: 'Asistente Administrativo/a' },
        { id: '180', text: 'Asistente Educativo' },
        { id: '184', text: 'Atletismo (ACLE / Taller)' },
        { id: '238', text: 'Auxiliar de Aseo' },
        { id: '185', text: 'Ballet (ACLE / Taller)' },
        { id: '186', text: 'Baloncesto (ACLE / Taller)' },
        { id: '187', text: 'Balonmano (ACLE / Taller)' },
        { id: '188', text: 'Banda cívica (ACLE / Taller)' },
        { id: '189', text: 'Básquetbol (ACLE / Taller)' },
        { id: '190', text: 'Batería y percusión (ACLE / Taller)' },
        { id: '5', text: 'Bibliotecario/a' },
        { id: '191', text: 'Cerámica (ACLE / Taller)' },
        { id: '192', text: 'Ciencias (ACLE / Taller)' },
        { id: '193', text: 'Clarinete (ACLE / Taller)' },
        { id: '6', text: 'Co Educador/a - Múltiples Menciones' },
        { id: '7', text: 'Co Educador/a Bilingüe - Múltiples Menciones' },
        { id: '194', text: 'Cocina & Gastronomía (ACLE / Taller)' },
        { id: '195', text: 'Comics e Ilustraciones (ACLE / Taller)' },
        { id: '196', text: 'Computación (ACLE / Taller)' },
        { id: '8', text: 'Confección Materiales de Estudio - Biología' },
        { id: '9', text: 'Confección Materiales de Estudio - Ciencias Naturales' },
        { id: '10', text: 'Confección Materiales de Estudio - Física' },
        { id: '11', text: 'Confección Materiales de Estudio - Historia, geografía y ciencias sociales' },
        { id: '12', text: 'Confección Materiales de Estudio - Inglés' },
        { id: '13', text: 'Confección Materiales de Estudio - Lengua y Literatura' },
        { id: '14', text: 'Confección Materiales de Estudio - Matemáticas' },
        { id: '15', text: 'Confección Materiales de Estudio - Química' },
        { id: '239', text: 'Contador/a' },
        { id: '16', text: 'Coordinador de Especialidad TP - Acuicultura' },
        { id: '17', text: 'Coordinador de Especialidad TP - Administración' },
        { id: '18', text: 'Coordinador de Especialidad TP - Agropecuaria' },
        { id: '19', text: 'Coordinador de Especialidad TP - Asistencia de Geología' },
        { id: '20', text: 'Coordinador de Especialidad TP - Atención de Enfermería' },
        { id: '21', text: 'Coordinador de Especialidad TP - Atención Párvulo' },
        { id: '22', text: 'Coordinador de Especialidad TP - Conectividad y redes' },
        { id: '23', text: 'Coordinador de Especialidad TP - Construcción' },
        { id: '24', text: 'Coordinador de Especialidad TP - Construcción metálicas' },
        { id: '25', text: 'Coordinador de Especialidad TP - Contabilidad' },
        { id: '26', text: 'Coordinador de Especialidad TP - Dibujo técnico' },
        { id: '27', text: 'Coordinador de Especialidad TP - Elaboración industrial de alimento' },
        { id: '28', text: 'Coordinador de Especialidad TP - Electricidad' },
        { id: '29', text: 'Coordinador de Especialidad TP - Electrónica' },
        { id: '30', text: 'Coordinador de Especialidad TP - Explotación Minera' },
        { id: '31', text: 'Coordinador de Especialidad TP - Forestal' },
        { id: '32', text: 'Coordinador de Especialidad TP - Gastronomía' },
        { id: '33', text: 'Coordinador de Especialidad TP - Gráfica' },
        { id: '34', text: 'Coordinador de Especialidad TP - Instalación Sanitaria' },
        { id: '35', text: 'Coordinador de Especialidad TP - Mecánica automotriz' },
        { id: '36', text: 'Coordinador de Especialidad TP - Mecánica de mantenimiento de aeronaves' },
        { id: '37', text: 'Coordinador de Especialidad TP - Mecánica industrial' },
        { id: '38', text: 'Coordinador de Especialidad TP - Metalúrgica Extractiva' },
        { id: '39', text: 'Coordinador de Especialidad TP - Montaje Industrial' },
        { id: '40', text: 'Coordinador de Especialidad TP - Muebles y terminaciones en marca' },
        { id: '41', text: 'Coordinador de Especialidad TP - Operaciones Portuarias' },
        { id: '42', text: 'Coordinador de Especialidad TP - Pesquería' },
        { id: '43', text: 'Coordinador de Especialidad TP - Programación' },
        { id: '44', text: 'Coordinador de Especialidad TP - Química Industrial' },
        { id: '45', text: 'Coordinador de Especialidad TP - Refrigeración y climatización' },
        { id: '46', text: 'Coordinador de Especialidad TP - Servicio de Hotelería' },
        { id: '47', text: 'Coordinador de Especialidad TP - Servicos de Turismo' },
        { id: '48', text: 'Coordinador de Especialidad TP - Telecomunicaciones' },
        { id: '49', text: 'Coordinador de Especialidad TP - Tripulación de naves Mercantes y especialista' },
        { id: '50', text: 'Coordinador de Especialidad TP - Vestuario y confección de textil' },
        { id: '51', text: 'Coordinador/a Académico' },
        { id: '52', text: 'Coordinador/a Actividades Extracurriculares' },
        { id: '53', text: 'Coordinador/a de Ciclo' },
        { id: '54', text: 'Coordinador/a de Convivencia Escolar' },
        { id: '55', text: 'Coordinador/a de Enlaces' },
        { id: '56', text: 'Coordinador/a PIE (Programa de Integración Escolar)' },
        { id: '197', text: 'Coro (ACLE / Taller)' },
        { id: '198', text: 'Cueca (ACLE / Taller)' },
        { id: '199', text: 'Danza (ACLE / Taller)' },
        { id: '57', text: 'Director/a' },
        { id: '58', text: 'Director/a Académico/a' },
        { id: '240', text: 'Diseñador/a' },
        { id: '59', text: 'Educador/a de párvulos' },
        { id: '60', text: 'Educador/a de párvulos Bilingüe' },
        { id: '61', text: 'Educador/a Diferencial' },
        { id: '62', text: 'Encargado/a de Admisión' },
        { id: '241', text: 'Encargado/a de Comunicaciones o Marketing' },
        { id: '63', text: 'Encargado/a de Convivencia Escolar' },
        { id: '64', text: 'Encargado/a de Formación' },
        { id: '176', text: 'Encargado/a de Laboratorio' },
        { id: '65', text: 'Encargado/a de Pastoral' },
        { id: '179', text: 'Enfermero/a' },
        { id: '200', text: 'Entrenamiento funcional (ACLE / Taller)' },
        { id: '201', text: 'Escalada (ACLE / Taller)' },
        { id: '202', text: 'Esgrima (ACLE / Taller)' },
        { id: '203', text: 'Expresión corporal (ACLE / Taller)' },
        { id: '242', text: 'Finanzas' },
        { id: '204', text: 'Flauta traversa (ACLE / Taller)' },
        { id: '205', text: 'Folclore (ACLE / Taller)' },
        { id: '66', text: 'Fonoaudiólogo/a' },
        { id: '206', text: 'Fotografía (ACLE / Taller)' },
        { id: '207', text: 'Fútbol (ACLE / Taller)' },
        { id: '67', text: 'Gestor/a Académico/a' },
        { id: '181', text: 'Gestor/a de Inclusión Laboral' },
        { id: '208', text: 'Gimnasia (Artística / Rítmica) (ACLE / Taller)' },
        { id: '209', text: 'Guitarra (ACLE / Taller)' },
        { id: '210', text: 'Guitarra eléctrica (ACLE / Taller)' },
        { id: '211', text: 'Hockey (ACLE / Taller)' },
        { id: '212', text: 'Idioma y cultura china (ACLE / Taller)' },
        { id: '213', text: 'Inglés (ACLE / Taller)' },
        { id: '68', text: 'Inspector/a' },
        { id: '69', text: 'Jefe/a de Área - Artístico' },
        { id: '70', text: 'Jefe/a de Área - Ciencias' },
        { id: '71', text: 'Jefe/a de Área - Humanista' },
        { id: '72', text: 'Jefe/a de Asuntos Estudiantiles' },
        { id: '246', text: 'Jefe/a de Informática' },
        { id: '73', text: 'Jefe/a Departamento Artes' },
        { id: '74', text: 'Jefe/a Departamento Ciencias naturales' },
        { id: '75', text: 'Jefe/a Departamento Educación física y salud' },
        { id: '76', text: 'Jefe/a Departamento Filosofía' },
        { id: '77', text: 'Jefe/a Departamento Historia, geografía y ciencias sociales' },
        { id: '78', text: 'Jefe/a Departamento Inglés' },
        { id: '79', text: 'Jefe/a Departamento Lengua y literatura' },
        { id: '80', text: 'Jefe/a Departamento Matemática' },
        { id: '81', text: 'Jefe/a Departamento Música' },
        { id: '82', text: 'Jefe/a Departamento Religión' },
        { id: '83', text: 'Jefe/a Departamento Tecnología' },
        { id: '84', text: 'Jefe/a UTP' },
        { id: '85', text: 'Jefe/a UTP - Técnico Profesional' },
        { id: '214', text: 'Karate (ACLE / Taller)' },
        { id: '215', text: 'Manualidades (ACLE / Taller)' },
        { id: '86', text: 'Orientador/a' },
        { id: '216', text: 'Pequeña orquesta (ACLE / Taller)' },
        { id: '217', text: 'Pintura (ACLE / Taller)' },
        { id: '218', text: 'Polideportivo (ACLE / Taller)' },
        { id: '243', text: 'Portero/a' },
        { id: '87', text: 'Practicante' },
        { id: '88', text: 'Profesor/a Acuicultura (TP)' },
        { id: '89', text: 'Profesor/a Administración (TP)' },
        { id: '90', text: 'Profesor/a Agropecuaria (TP)' },
        { id: '91', text: 'Profesor/a Alemán' },
        { id: '92', text: 'Profesor/a Artes' },
        { id: '93', text: 'Profesor/a Artes - Electivos III y IV medio' },
        { id: '94', text: 'Profesor/a Asistencia de Geología (TP)' },
        { id: '95', text: 'Profesor/a Atención de Enfermería (TP)' },
        { id: '96', text: 'Profesor/a Atención Párvulo (TP)' },
        { id: '97', text: 'Profesor/a Biología' },
        { id: '98', text: 'Profesor/a Biología - Electivos III y IV medio' },
        { id: '99', text: 'Profesor/a Ciencias naturales' },
        { id: '100', text: 'Profesor/a Ciencias para la ciudadanía' },
        { id: '101', text: 'Profesor/a Conectividad y redes (TP)' },
        { id: '102', text: 'Profesor/a Construcción (TP)' },
        { id: '103', text: 'Profesor/a Construcción metálicas (TP)' },
        { id: '104', text: 'Profesor/a Contabilidad (TP)' },
        { id: '177', text: 'Profesor/a Cultura Religiosa' },
        { id: '105', text: 'Profesor/a de Computación' },
        { id: '106', text: 'Profesor/a de Convivencia Social, Consumo y Calidad de Vida' },
        { id: '107', text: 'Profesor/a de Inserción Laboral' },
        { id: '108', text: 'Profesor/a Dibujo técnico (TP)' },
        { id: '109', text: 'Profesor/a economía y sociedad' },
        { id: '110', text: 'Profesor/a Ed. Básica - Múltiples menciones' },
        { id: '111', text: 'Profesor/a Ed. Básica Bilingüe' },
        { id: '112', text: 'Profesor/a Educación ciudadana' },
        { id: '113', text: 'Profesor/a Educación física y salud' },
        { id: '114', text: 'Profesor/a Educación física y salud - Electivos III y IV medio' },
        { id: '115', text: 'Profesor/a Elaboración industrial de alimento (TP)' },
        { id: '116', text: 'Profesor/a Electricidad (TP)' },
        { id: '117', text: 'Profesor/a Electrónica (TP)' },
        { id: '118', text: 'Profesor/a Explotación Minera (TP)' },
        { id: '119', text: 'Profesor/a Filosofía' },
        { id: '120', text: 'Profesor/a Filosofía - Electivos III y IV medio' },
        { id: '121', text: 'Profesor/a Física' },
        { id: '122', text: 'Profesor/a Física - Electivos III y IV medio' },
        { id: '123', text: 'Profesor/a Flotante' },
        { id: '124', text: 'Profesor/a Forestal (TP)' },
        { id: '125', text: 'Profesor/a Francés' },
        { id: '126', text: 'Profesor/a Gastronomía (TP)' },
        { id: '127', text: 'Profesor/a Gráfica (TP)' },
        { id: '128', text: 'Profesor/a Historia, geografía y ciencias sociales' },
        { id: '129', text: 'Profesor/a Historia, geografía y ciencias sociales - Electivos III y IV medio' },
        { id: '130', text: 'Profesor/a idiomas (no inglés)' },
        { id: '131', text: 'Profesor/a Inglés' },
        { id: '132', text: 'Profesor/a Instalación Sanitaria (TP)' },
        { id: '133', text: 'Profesor/a Italiano' },
        { id: '134', text: 'Profesor/a Jefe' },
        { id: '135', text: 'Profesor/a Lengua indígena' },
        { id: '136', text: 'Profesor/a Lengua y Cultura de los Pueblos Originarios Ancestrales' },
        { id: '137', text: 'Profesor/a Lengua y literatura' },
        { id: '138', text: 'Profesor/a Lengua y literatura - Electivos III y IV medio' },
        { id: '139', text: 'Profesor/a Lenguas Indígenas' },
        { id: '140', text: 'Profesor/a Matemática' },
        { id: '141', text: 'Profesor/a Matemática - Electivos III y IV medio' },
        { id: '142', text: 'Profesor/a Mecánica automotriz (TP)' },
        { id: '143', text: 'Profesor/a Mecánica de mantenimiento de aeronaves (TP)' },
        { id: '144', text: 'Profesor/a Mecánica industrial (TP)' },
        { id: '145', text: 'Profesor/a Metalúrgica Extractiva (TP)' },
        { id: '146', text: 'Profesor/a Montaje Industrial (TP)' },
        { id: '147', text: 'Profesor/a Muebles y terminaciones en marca (TP)' },
        { id: '148', text: 'Profesor/a Música' },
        { id: '149', text: 'Profesor/a Operaciones Portuarias (TP)' },
        { id: '150', text: 'Profesor/a Pesquería (TP)' },
        { id: '151', text: 'Profesor/a Programación (TP)' },
        { id: '152', text: 'Profesor/a Química' },
        { id: '153', text: 'Profesor/a Química - Electivos III y IV medio' },
        { id: '154', text: 'Profesor/a Química Industrial (TP)' },
        { id: '155', text: 'Profesor/a Refrigeración y climatización (TP)' },
        { id: '156', text: 'Profesor/a Religión' },
        { id: '157', text: 'Profesor/a Servicio de Hotelería (TP)' },
        { id: '158', text: 'Profesor/a Servicos de Turismo (TP)' },
        { id: '159', text: 'Profesor/a Tecnología' },
        { id: '160', text: 'Profesor/a Telecomunicaciones (TP)' },
        { id: '161', text: 'Profesor/a Tripulación de naves Mercantes y especialista (TP)' },
        { id: '162', text: 'Profesor/a Vestuario y confección de textil (TP)' },
        { id: '163', text: 'Profesor/a Volante' },
        { id: '219', text: 'Programación (ACLE / Taller)' },
        { id: '220', text: 'Psicomotricidad (ACLE / Taller)' },
        { id: '164', text: 'Psicopedagogo/a' },
        { id: '221', text: 'Radio escolar (ACLE / Taller)' },
        { id: '244', text: 'Recursos Humanos' },
        { id: '222', text: 'Robótica (ACLE / Taller)' },
        { id: '223', text: 'Rugby (ACLE / Taller)' },
        { id: '224', text: 'Scout (ACLE / Taller)' },
        { id: '245', text: 'Secretario/a' },
        { id: '165', text: 'Secretario/a Académico/a' },
        { id: '166', text: 'Secretario/a Educacional' },
        { id: '251', text: 'Prevencionista de Riesgos' },
        { id: '167', text: 'Psicólogo/a' },
        { id: '168', text: 'Psicólogo/a PIE' },
        { id: '249', text: 'Soporte en Informática' },
        { id: '169', text: 'Sub-Coordinador/a PIE (Programa de Integración Escolar)' },
        { id: '170', text: 'Subdirector/a' },
        { id: '225', text: 'Teatro (ACLE / Taller)' },
        { id: '171', text: 'Técnico de párvulos' },
        { id: '178', text: 'Técnico en Educación' },
        { id: '172', text: 'Técnico en Educación Especial' },
        { id: '226', text: 'Tenis (ACLE / Taller)' },
        { id: '227', text: 'Tenis de mesa (ACLE / Taller)' },
        { id: '173', text: 'Terapeuta ocupacional' },
        { id: '174', text: 'Trabajador/a Social' },
        { id: '182', text: 'Tutor/a' },
        { id: '228', text: 'Ukelele (ACLE / Taller)' },
        { id: '229', text: 'Viola (ACLE / Taller)' },
        { id: '230', text: 'Violín (ACLE / Taller)' },
        { id: '232', text: 'Violoncello (ACLE / Taller)' },
        { id: '233', text: 'Vóleibol (ACLE / Taller)' },
        { id: '234', text: 'Yoga (ACLE / Taller)' },
        { id: '235', text: 'Zumba (ACLE / Taller)' },
    ];
